/* Shared collection and suggested-product card controls. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.RockEmProductCardUI = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const HEART_SVG =  '<svg aria-hidden="true" class="heart-outline" width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.0761 2.34319C16.6504 1.91736 16.1451 1.57956 15.5889 1.34909C15.0327 1.11862 14.4365 1 13.8344 1C13.2323 1 12.6362 1.11862 12.0799 1.34909C11.5237 1.57956 11.0184 1.91736 10.5927 2.34319L9.70941 3.22652L8.82608 2.34319C7.96633 1.48344 6.80027 1.00045 5.58441 1.00045C4.36855 1.00045 3.20249 1.48344 2.34274 2.34319C1.483 3.20293 1 4.36899 1 5.58485C1 6.80071 1.483 7.96678 2.34274 8.82652L9.70941 16.1932L17.0761 8.82652C17.5019 8.40089 17.8397 7.89553 18.0702 7.33932C18.3006 6.7831 18.4193 6.18693 18.4193 5.58485C18.4193 4.98278 18.3006 4.38661 18.0702 3.83039C17.8397 3.27418 17.5019 2.76882 17.0761 2.34319Z" fill="white" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + '<svg aria-hidden="true" class="heart-filled" viewBox="0 0 24 24" fill="#e53e3e" stroke="#e53e3e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function createWishlistButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-wishlist-btn';
    button.setAttribute('aria-label', 'Add to wishlist');
    button.innerHTML = HEART_SVG;
    return button;
  }

  function mountDesignCarousel(rail, viewport) {
    rail.classList.add('cb-carousel');
    viewport.classList.add('cb-viewport');
    function arrow(direction) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cb-arrow ' + (direction < 0 ? 'left' : 'right');
      button.setAttribute('aria-label', direction < 0 ? 'Previous designs' : 'Next designs');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' +
        (direction < 0 ? 'M15 18l-6-6 6-6' : 'M9 6l6 6-6 6') +
        '" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.addEventListener('click', () => viewport.scrollBy({ left: direction * viewport.clientWidth, behavior: 'smooth' }));
      return button;
    }
    const previous = arrow(-1), next = arrow(1);
    rail.append(previous, viewport, next);
    let wasConnected = false;
    function update() {
      if (rail.isConnected) wasConnected = true;
      else if (wasConnected) observer?.disconnect();
      const overflow = viewport.scrollWidth - viewport.clientWidth > 2;
      previous.disabled = !overflow || viewport.scrollLeft <= 0;
      next.disabled = !overflow || viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
      rail.classList.toggle('has-overflow', overflow);
    }
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    observer?.observe(viewport);
    viewport.addEventListener('scroll', update, { passive: true });
    requestAnimationFrame(update);
    return { previous, next, update };
  }

  return { createWishlistButton, mountDesignCarousel };
});
